// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"740c08ef","428":"9c4169a7"}[chunkId] + ".chunk.js";
};